module.exports = __webpack_public_path__ + "assets/img/title-825182af.png";